import { M8PartnerBalance } from 'services/production/types';
import { createQueryString } from 'services/production/utils/createQueryString';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';

type Props = {
  idPartner: number;
};

export async function getPartnerBalance(
  props: Props
): Promise<null | M8PartnerBalance> {
  const url = getM8AdminURL(`getPartnerBalance?${createQueryString(props)}`);

  const response = await fetch(url);

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  if (response.status === 200) {
    return response.json();
  }

  return null;
}
